import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_dev')({
  component: DevLayout,
})

function DevLayout() {
  // Only render in development
  if (import.meta.env.PROD) {
    return <div>Dev routes not available in production</div>
  }
  return <Outlet />
}
